export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_06-dfb015f328b2e617ba64d2b67468cdc6.jpg";